
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { LinkGrid } from '../../app/components';
import { patterns } from '../../__configuration__/patterns';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* KEYWORDS: design pattern */
    }
    <h1>{`Design Patterns`}</h1>
    <p>{`Design Patterns are common interactions or functionality that exist across different applications. Brightlayer UI provides several patterns for items that often come up in our applications. These patterns include detailed descriptions of when and where to apply the pattern as well as code examples that show you how you can implement them in any of our supported frameworks. If we don't have a pattern for something specific, you can also browse the `}<a parentName="p" {...{
        "href": "https://material.io/design/guidelines-overview/"
      }}>{`Material Design patterns`}</a>{`.`}</p>
    <LinkGrid links={patterns} style={{
      marginTop: 32
    }} mdxType="LinkGrid" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;